import { mapActions } from 'vuex';
import Events from '_utils/events';
import UserService from '_services/rest/modules/user';

export default {
  name: 'user-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      UserService.deleteUser(this.selectUser)
        .then(() => {
          this.close();
          this.$router.push('/admin/usuarios/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: this.$t('user.alert.deleted'), theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
